export const SET_CONSULTATION_LIST = "SET_CONSULTATION_LIST";
export const SET_CONSULTATION_LOADING = "SET_CONSULTATION_LOADING";
export const SET_CONSULTATION_PAGE = "SET_CONSULTATION_PAGE";
export const CLEAR_CONSULTATION_STORE = "CLEAR_CONSULTATION_STORE";
export const SET_CONSULTATION_FILTER = "SET_CONSULTATION_FILTER";
